// extracted by mini-css-extract-plugin
export var callout = "index-module--callout--+ZEjI";